import React, { HTMLProps, PropsWithChildren } from 'react';
import styles from './form-group.module.css';

export const FormGroup = ({
  children,
  className,
  ...props
}: PropsWithChildren<HTMLProps<HTMLDivElement>>) => (
  <div {...props} className={`${className} ${styles.formGroup}`}>
    {children}
  </div>
);
